import { useIsPath } from './useIsPath';

export const useIsOnStart = () => {
  const isOnHome = useIsPath('/', { endsWith: true });
  const isOnProjectList = useIsPath('projectId');
  const isOnMyProjects = useIsPath('my-projects');
  const isOnProjectListCachedTenders = useIsPath('invitations');
  const isOnProjectListMyTenders = useIsPath('my-tenders');

  const isOnStart =
    isOnProjectListCachedTenders ||
    isOnProjectListMyTenders ||
    isOnProjectList ||
    isOnMyProjects ||
    isOnHome;

  return isOnStart;
};
